export async function isDeleteConfirmed(many = false, title = null, showBaseFieldDeleteCheckbox = false) {
  let titleLocal = title;

  if (!titleLocal) {
    if(many){
      titleLocal = 'Are you sure you want to delete these fields?';
    }else{
      titleLocal = 'Are you sure you want to delete this field?';
    }
  }

  let handler = null;
  const result = await Swal.fire({
    title: `<div style="text-align: left;font-size: 1.25rem; font-weight: 600; color: #1d1f22;">Delete Field</div>`,
    keydownListenerCapture: true,
    showCancelButton: true,
    cancelButtonText: 'Cancel',
    confirmButtonText: 'Delete Field',
    reverseButtons: true,
    focusConfirm: true,
    focusCancel: false,
    showCloseButton: true,
    width: '32em',
    html: `
        <div style="text-align: left;font-size: 0.95rem; color: #4a4a4a;margin-top: 10px;">
          ${ titleLocal }
          This action cannot be undone.
        </div>
      `,
    didOpen: () => {
      //remove focus from buttons
      Swal.getPopup().querySelector('button.swal2-cancel')?.blur();
      Swal.getPopup().querySelector('button.swal2-close')?.blur();

      handler = (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          Swal.clickConfirm();
        }
      };

      document.addEventListener("keydown", handler);

      const actions = Swal.getActions();
      const wrapper = document.createElement('div');
      wrapper.innerHTML = showBaseFieldDeleteCheckbox ? `
          <div id="advancedToggle"
              style="font-size: 0.9rem; color: #1d1f22; font-weight: 500; margin-bottom: 0.5rem; margin-top:5px; cursor:pointer;">
            Advanced options <i class="bi bi-chevron-down"></i>
          </div>
          <div class="collapse" id="advancedOptionsCollapse">
            <div class="d-flex flex-row align-items-baseline">
              <input type="checkbox" id="deleteFromBase"
                    style="accent-color:#007964; margin-right:6px;" />
              <div class="d-flex flex-column">
                <span style="font-size:0.8rem; color:#1d1f22;">Delete from base template</span>
                <span style="font-size: 0.8rem; color: #6b7280;">
                  This will remove the field from the base template
                </span>
              </div>
            </div>
          </div>
        ` : '';
      wrapper.style.borderTop = '1px solid #e4e5e7';
      wrapper.style.paddingTop = '6px';
      wrapper.style.marginLeft = '10px';
      wrapper.style.width = '40%';

      actions.appendChild(wrapper);
      const $popup = $(Swal.getPopup());
      const $collapse = $popup.find('#advancedOptionsCollapse');
      $collapse.collapse({ toggle: false });

      // Toggle manually on click
      const $toggle = $popup.find('#advancedToggle');
      $toggle.on('click', function () {
        if ($collapse.hasClass('show')) {
          $collapse.collapse('hide');
          $(this).find('i').removeClass('bi-chevron-up').addClass('bi-chevron-down');
        } else {
          $collapse.collapse('show');
          $(this).find('i').removeClass('bi-chevron-down').addClass('bi-chevron-up');
        }
      });
    },
    willClose: () => {
      document.removeEventListener("keydown", handler);
    },
    customClass: {
      popup: 'swal2-modern-dialog delete-field-swal',
      confirmButton: 'swal2-delete-btn',
      cancelButton: 'swal2-cancel-btn',
      htmlContainer: 'swal-no-padding',
      closeButton: 'delete-field-close',
    },
    preConfirm: () => {
      if (showBaseFieldDeleteCheckbox) {
        return {
          confirmed: true,
          deleteFromBase: document.getElementById('deleteFromBase').checked
        };
      }
      return true;
    }
  });

  if (!result.isConfirmed) return false;

  return result.value;
}
